import { useAppSelector } from 'hooks/useAppSelector';
import { useIntl } from 'react-intl';
import { selectEssentialTabName } from 'routes/essential-workspace/state/form.selectors';

export function useEssentialTabName(formId: string) {
  const { formatMessage } = useIntl();

  const label = useAppSelector(state => selectEssentialTabName(state, formId));

  if (!label) {
    return;
  }

  return label.name ?? formatMessage({ id: 'essential.workspace.side.panel.defaultQuoteName' }, { index: label.index });
}
